/**
 * "· edited" after a visit note's byline, with who and when on hover.
 *
 * Spelled out as "· edited by {name}" when someone other than the
 * author made the change — usually an admin correcting a rep's note —
 * because that's the case a reader would otherwise never guess.
 */

import { Box, Tooltip } from '@mui/material';

export function EditedMarker({
  editedAt,
  editedByName,
  someoneElse,
}: {
  editedAt: string | null;
  editedByName: string | null;
  someoneElse: boolean;
}) {
  if (!editedAt) return null;

  const when = new Date(editedAt).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  const by = editedByName ? `Edited by ${editedByName}` : 'Edited';

  return (
    <Tooltip title={`${by} · ${when}`}>
      <Box component="span" sx={{ fontStyle: 'italic', cursor: 'default' }}>
        {someoneElse && editedByName ? ` · edited by ${editedByName}` : ' · edited'}
      </Box>
    </Tooltip>
  );
}
